export default function SecondaryHeading({
  style = {},
  className,
  onClick,
  children,
  ...props
}) {
  return (
    <>
      <h2
        className={`secondary-heading transition-all ${
          className ?? ""
        } capitalize`}
        onClick={onClick}
        style={style}
        {...props}
      >
        {children}
      </h2>
    </>
  );
}
